import { render, staticRenderFns } from "./ChangePasswordForm.vue?vue&type=template&id=2063e1ee&scoped=true&"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordForm.vue?vue&type=style&index=0&id=2063e1ee&lang=scss&scoped=true&"
import style1 from "./ChangePasswordForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2063e1ee",
  null
  
)

export default component.exports